import AdminReports from '@/pages/admin/AdminReports';

export default function AdminSalesReports() {
  return <AdminReports mode="sales" />;
}
